/**
 * Wraps a promise with a timeout. Rejects with an error if the promise
 * doesn't resolve within the given number of milliseconds.
 */
export function withTimeout<T>(promise: PromiseLike<T>, ms = 8000): Promise<T> {
  return Promise.race([
    Promise.resolve(promise),
    new Promise<never>((_, reject) =>
      setTimeout(() => reject(new Error('Request timed out. Please try again.')), ms)
    ),
  ]);
}
